// extracted by mini-css-extract-plugin
export default {"section":"About_section__08CZB","article":"About_article__oFpDZ","img":"About_img__ThOzN"};